export default __webpack_public_path__ + "d9c714ce6c1c57a05a0cc9c3db16a521.png";